module.exports = __webpack_public_path__ + "static/media/thunder_img.b6dc3fe9.png";